import React, { Component } from "react";
import {
  Button,
  Container,
  Row,Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

export default class Taskpenalitypoints extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.taskpenalitypoints_Id,
          sortable: true,
          cell: (row) => <span>{row.taskpenalitypoints_Id}</span>,
        },
        {name:"Ittasks_Id",selector:(row, i) => row.ittasks_Id,sortable:true,cell: (row) => <span>{row.ittasks_Id}</span>,},{name:"Uid",selector:(row, i) => row.uId,sortable:true,cell: (row) => <span>{row.uId}</span>,},{name:"Stage Name",selector:(row, i) => row.stageName,sortable:true,cell: (row) => <span>{row.stageName}</span>,},{name:"Given Time",selector:(row, i) => row.givenTime,sortable:true,cell: (row) => <span>{row.givenTime}</span>,},{name:"Done Time",selector:(row, i) => row.doneTime,sortable:true,cell: (row) => <span>{row.doneTime}</span>,},{name:"Penalty Points",selector:(row, i) => row.penaltyPoints,sortable:true,cell: (row) => <span>{row.penaltyPoints}</span>,},{name:"Is Reversed",selector:(row, i) => row.isReversed,sortable:true,cell: (row) => <span>{row.isReversed}</span>,},{name:"Reversal Reason",selector:(row, i) => row.reversalReason,sortable:true,cell: (row) => <span>{row.reversalReason}</span>,},{name:"Remarks",selector:(row, i) => row.Remarks,sortable:true,cell: (row) => <span>{row.Remarks}</span>,},
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
              style={{marginRight:"10px"}}
                variant="primary"
                onClick={() => this.TaskpenalitypointseditHandler(row)}
                className="bi bi-pen" 
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
     taskpenalitypoints_Id:"",
      ittasks_Id:'',uId:'',stageName:'',givenTime:'',doneTime:'',penaltyPoints:'',isReversed:'',reversalReason:'',Remarks:'',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;
    
    let validationResult = { isValid: true, message: "" };
    
    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;
        
      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;
        
      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;
        
      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;
        
      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;
        
      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;
        
      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;
        
      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;
        
      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;
        
      default:
        validationResult = { isValid: true, message: "" };
    }
    
    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }
    
    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }
    
    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({ 
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;
    
    // Auto-generated required field validation
    // No required fields defined
    
    
    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'ittasks_Id', inputType: 'Text', displayName: 'Ittasks_Id', validationOptions: { isRequired: false } },
      { fieldName: 'uId', inputType: 'Text', displayName: 'Uid', validationOptions: { isRequired: false } },
      { fieldName: 'stageName', inputType: 'Text', displayName: 'Stage Name', validationOptions: { isRequired: false } },
      { fieldName: 'givenTime', inputType: 'Text', displayName: 'Given Time', validationOptions: { isRequired: false } },
      { fieldName: 'doneTime', inputType: 'Text', displayName: 'Done Time', validationOptions: { isRequired: false } },
      { fieldName: 'penaltyPoints', inputType: 'Text', displayName: 'Penalty Points', validationOptions: { isRequired: false } },
      { fieldName: 'isReversed', inputType: 'Text', displayName: 'Is Reversed', validationOptions: { isRequired: false } },
      { fieldName: 'reversalReason', inputType: 'Text', displayName: 'Reversal Reason', validationOptions: { isRequired: false } },
      { fieldName: 'Remarks', inputType: 'Text', displayName: 'Remarks', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });
    
  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({ 
      show: true, 
      errors: {},
      touched: {},
      ittasks_Id:'',uId:'',stageName:'',givenTime:'',doneTime:'',penaltyPoints:'',isReversed:'',reversalReason:'',Remarks:'', 
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ 
      show: false,
      isEditing: false, 
      errors: {},
      touched: {},
      ittasks_Id:'',uId:'',stageName:'',givenTime:'',doneTime:'',penaltyPoints:'',isReversed:'',reversalReason:'',Remarks:'', 
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch(type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
     }   
  };

  TaskpenalitypointseditHandler = (row)=>{
      this.setState({ 
        isEditing: true,
        show: true,
        taskpenalitypoints_Id: row.taskpenalitypoints_Id, 
        ittasks_Id:row.ittasks_Id,uId:row.uId,stageName:row.stageName,givenTime:row.givenTime,doneTime:row.doneTime,penaltyPoints:row.penaltyPoints,isReversed:row.isReversed,reversalReason:row.reversalReason,Remarks:row.Remarks,
        //***editstate
        errors: {},
        touched: {}
      });
  }
       
  TaskpenalitypointsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    
    fetch(configData.api_url +'C_Taskpenalitypoints/list', {
      method: 'POST', 
      mode: 'cors', 
      body: formData
    })
    .then(response => response.json())
    .then((data) => {
      if (data.status === "success") {
        this.setState({ data: data.list });
      }
    })
    .catch((error) => {
      console.error("Fetch error:", error);
      this.showToast("Failed to load data", "error");
    });
  }

  TaskpenalitypointssubmitHandler = (e) => {
    e.preventDefault();
    
    // Validate all fields before submission
    this.validateAllFields();
    
    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }
    
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('ittasks_Id',this.state.ittasks_Id);
formData.append('uId',this.state.uId);
formData.append('stageName',this.state.stageName);
formData.append('givenTime',this.state.givenTime);
formData.append('doneTime',this.state.doneTime);
formData.append('penaltyPoints',this.state.penaltyPoints);
formData.append('isReversed',this.state.isReversed);
formData.append('reversalReason',this.state.reversalReason);
formData.append('Remarks',this.state.Remarks);

    //***tableData*
    
    fetch(configData.api_url + 'C_Taskpenalitypoints/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
    .then(response => response.json())
    .then((data) => {
      this.showToast(data.message, data.status);
      if (data.status === "success") {
        this.TaskpenalitypointsfetchHandler();
        this.handleOffcanvasClose();
        this.setState({ ittasks_Id:'',uId:'',stageName:'',givenTime:'',doneTime:'',penaltyPoints:'',isReversed:'',reversalReason:'',Remarks:'', });
      }
    })
    .catch((error) => {
      console.error("Submit error:", error);
      this.showToast("Failed to save data", "error");
    });
  }

  TaskpenalitypointsupdateHandler = (e) => {
    e.preventDefault();
    
    // Validate all fields before submission
    this.validateAllFields();
    
    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }
    
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("taskpenalitypoints_Id", this.state.taskpenalitypoints_Id);
    formData.append('ittasks_Id',this.state.ittasks_Id);
formData.append('uId',this.state.uId);
formData.append('stageName',this.state.stageName);
formData.append('givenTime',this.state.givenTime);
formData.append('doneTime',this.state.doneTime);
formData.append('penaltyPoints',this.state.penaltyPoints);
formData.append('isReversed',this.state.isReversed);
formData.append('reversalReason',this.state.reversalReason);
formData.append('Remarks',this.state.Remarks);

    //***tableData1
    
    fetch(configData.api_url +'C_Taskpenalitypoints/update', {  
      method: 'POST', 
      mode: 'cors', 
      body: formData
    })
    .then(response => response.json())
    .then((data) => {
      this.showToast(data.message, data.status);
      if (data.status === "success") {
        this.TaskpenalitypointsfetchHandler();
        this.handleOffcanvasClose();
      }
    })
    .catch((error) => {
      console.error("Update error:", error);
      this.showToast("Failed to update data", "error");
    });
  }

  componentDidMount() {
    this.TaskpenalitypointsfetchHandler();
    
     //***componentDidMount
  }

  handleittasks_IdChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({ittasks_Id: fieldValue });
};handleuIdChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({uId: fieldValue });
};handlestageNameChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({stageName: fieldValue });
};handlegivenTimeChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({givenTime: fieldValue });
};handledoneTimeChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({doneTime: fieldValue });
};handlepenaltyPointsChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({penaltyPoints: fieldValue });
};handleisReversedChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({isReversed: fieldValue });
};handlereversalReasonChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({reversalReason: fieldValue });
};handleRemarksChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({Remarks: fieldValue });
};
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this taskpenalitypoints?`)) {
      return;
    }
    
    var formData = new FormData();
    formData.append('taskpenalitypoints_Id', row.taskpenalitypoints_Id);
    
    fetch(configData.api_url +'C_Taskpenalitypoints/delete', {
      method: 'POST', 
      mode: 'cors', 
      body: formData
    })
    .then(response => response.json())
    .then((data) => {
      this.showToast(data.message, data.status);
      if (data.status === "success") {
        this.TaskpenalitypointsfetchHandler();
      }
    })
    .catch((error) => {
      console.error("Delete error:", error);
      this.showToast("Failed to delete data", "error");
    });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];
    
    let inputElement;
    
    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;
        
      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;
        
      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;
        
      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;
        
      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;
        
      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;
        
      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;
        
      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }
    
    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;
    
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage
        )
      : this.state.data.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage
        );

    return (
      <div className="page-title">
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="x_panel">
            <div className="x_content">
              <div
                id="datatable_wrapper"
                className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
              >
                <Row className="row">
                <div>
                 <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Task Penality Points</h3>
                </div>
            <Col
            className="d-flex justify-content-end"
            style={{ marginRight: "5px", marginTop: "20px" }}
          >
           <Button
                variant="primary" style={{ float: "right", marginBottom: "10px" }}
                className="bi bi-plus "
                onClick={this.handleOffcanvasShow}
              >
              New
              </Button>

            {/* Enhanced Add Offcanvas */}
            <Offcanvas
              show={this.state.show && !this.state.isEditing}
              onHide={this.handleOffcanvasClose}
              {...this.props}
              style={{ width: "500px" }}
              placement="end"
              backdrop="true"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Add Taskpenalitypoints</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Container style={{ "overflowY": "auto", height: "auto" }}>
                  
                  {/* Error Summary */}
                  {Object.keys(errors).length > 0 && (
                    <div className="alert alert-danger mb-3">
                      <strong>Please fix the following errors:</strong>
                      <ul className="mb-0 mt-2">
                        {Object.entries(errors).map(([field, error]) => (
                          <li key={field}>{error}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                <Row className="divstyle">
                    <Row>
                      <Form>
                  <Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Ittasks_Id</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleittasks_IdChange} className="form-control" name="ittasks_Id" value={this.state.ittasks_Id} required="required" placeholder="Enter Ittasks_Id" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.ittasks_Id} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Uid</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleuIdChange} className="form-control" name="uId" value={this.state.uId} required="required" placeholder="Enter Uid" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.uId} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Stage Name</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlestageNameChange} className="form-control" name="stageName" value={this.state.stageName} required="required" placeholder="Enter Stage Name" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.stageName} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Given Time</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlegivenTimeChange} className="form-control" name="givenTime" value={this.state.givenTime} required="required" placeholder="Enter Given Time" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.givenTime} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Done Time</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handledoneTimeChange} className="form-control" name="doneTime" value={this.state.doneTime} required="required" placeholder="Enter Done Time" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.doneTime} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Penalty Points</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlepenaltyPointsChange} className="form-control" name="penaltyPoints" value={this.state.penaltyPoints} required="required" placeholder="Enter Penalty Points" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.penaltyPoints} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Is Reversed</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleisReversedChange} className="form-control" name="isReversed" value={this.state.isReversed} required="required" placeholder="Enter Is Reversed" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.isReversed} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Reversal Reason</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlereversalReasonChange} className="form-control" name="reversalReason" value={this.state.reversalReason} required="required" placeholder="Enter Reversal Reason" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.reversalReason} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Remarks</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleRemarksChange} className="form-control" name="Remarks" value={this.state.Remarks} required="required" placeholder="Enter Remarks" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.Remarks} </div>
</Row><br/>
                  {/* tableContent */}
                  {/* Auto-generated form content with validation */}
                  </Form>
                  </Row>
                  </Row>
                  <Row>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "50px" }}
                    >
                      <Button
                        className="button"
                        variant="success"
                        onClick={this.TaskpenalitypointssubmitHandler}
                        disabled={!this.isFormValid()}
                        style={{
                          marginTop: "20px",
                        }}
                      >
                        Save
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </Offcanvas.Body>
            </Offcanvas>

            {/* Enhanced Edit Offcanvas */}
            {this.state.isEditing && (
              <Offcanvas
              show={this.state.isEditing}
              onHide={this.handleOffcanvasClose}
              {...this.props}
              style={{ width: "500px" }}
              placement="end"
              backdrop="true"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Edit Taskpenalitypoints</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Container style={{ "overflowY": "auto", height: "auto" }}>
                  
                  {/* Error Summary */}
                  {Object.keys(errors).length > 0 && (
                    <div className="alert alert-danger mb-3">
                      <strong>Please fix the following errors:</strong>
                      <ul className="mb-0 mt-2">
                        {Object.entries(errors).map(([field, error]) => (
                          <li key={field}>{error}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                <Row className="divstyle">
                    <Row>
                      <Form>
                  <Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Ittasks_Id</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleittasks_IdChange} className="form-control" name="ittasks_Id" value={this.state.ittasks_Id} required="required" placeholder="Enter Ittasks_Id" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.ittasks_Id} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Uid</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleuIdChange} className="form-control" name="uId" value={this.state.uId} required="required" placeholder="Enter Uid" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.uId} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Stage Name</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlestageNameChange} className="form-control" name="stageName" value={this.state.stageName} required="required" placeholder="Enter Stage Name" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.stageName} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Given Time</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlegivenTimeChange} className="form-control" name="givenTime" value={this.state.givenTime} required="required" placeholder="Enter Given Time" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.givenTime} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Done Time</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handledoneTimeChange} className="form-control" name="doneTime" value={this.state.doneTime} required="required" placeholder="Enter Done Time" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.doneTime} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Penalty Points</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlepenaltyPointsChange} className="form-control" name="penaltyPoints" value={this.state.penaltyPoints} required="required" placeholder="Enter Penalty Points" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.penaltyPoints} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Is Reversed</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleisReversedChange} className="form-control" name="isReversed" value={this.state.isReversed} required="required" placeholder="Enter Is Reversed" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.isReversed} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Reversal Reason</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlereversalReasonChange} className="form-control" name="reversalReason" value={this.state.reversalReason} required="required" placeholder="Enter Reversal Reason" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.reversalReason} </div>
</Row><br/><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Remarks</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleRemarksChange} className="form-control" name="Remarks" value={this.state.Remarks} required="required" placeholder="Enter Remarks" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.Remarks} </div>
</Row><br/>
                  {/* tableContent */}
                  {/* Auto-generated form content with validation */}
                  </Form>
                  </Row>
                  </Row>
                  <Row>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "50px" }}
                    >
                      <Button
                        className="button"
                        variant="success"
                        onClick={this.TaskpenalitypointsupdateHandler}
                        disabled={!this.isFormValid()}
                        style={{
                          marginTop: "20px",
                        }}
                      >
                        Update
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </Offcanvas.Body>
            </Offcanvas>
            )}
        {/*offcanvas is over */}
                  </Col> 
                  </Row>
        <br />
        <Row>
<div style={{"marginRight":"5px"}}>
  {/* searchbar,pagination,filter */}
  <input
    type="text"
    style={{ float: "left", marginBottom: "10px" }}
    onChange={this.handleFilter}
    placeholder="Search..."
  />
  <DataTable
    data={paginatedData}
    columns={this.state.tableClms}
    pagination
    paginationServer
    paginationTotalRows={
      this.state.filteredData
        ? this.state.filteredData.length
        : this.state.data.length
    }
    onChangeRowsPerPage={this.handlePerRowsChange}
    onChangePage={this.handlePageChange}
    paginationPerPage={this.state.itemsPerPage}
    keyField="id"
    className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
  />
</div>
  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}